import { DashboardAPI } from "utils/api";

export const runEnergyPlusAPI = async (modelId, expVersion, upgradePackage) => {
    return DashboardAPI({
        method: "POST",
        url: "/runEnergyPlusSimulation",
        data: {
            modelId,
            expVersion,
            upgradePackage,
        },
    });
};
